import React, { useEffect, useState } from 'react'
import { FaUserNurse } from 'react-icons/fa6'
import { ImCancelCircle } from "react-icons/im";
import { FaCheckCircle } from "react-icons/fa";
import { FaCirclePause } from "react-icons/fa6";
import adminServices from '../../services/AdminServices';

function NurseStats() {
    const [statistics, setStatics] = useState()
    useEffect(() => {
        adminServices.nursesStats().then(
            res => {
                setStatics(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }, [])
    useEffect(() => { }, [statistics])
    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Total Nurses</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.nurse_count}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3 ">
                            <span className="material-symbols-outlined"><FaUserNurse className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Approved</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.approved_count}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><FaCheckCircle className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Unapproved</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.unapproved_count}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><ImCancelCircle className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Suspended</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.suspended_count}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><FaCirclePause className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NurseStats